import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import useAuth from '../Hooks/useAuth';
import useLocalStorage from "../Hooks/useLocalStorage";
import { Row, Col, Form, FormGroup, Label, Input, Button, Card, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import { apiGet, apiPost } from "../Hooks/apiWrapper";
const Auth0Success = () => {
    const { setAuth } = useAuth();
    const { isAuthenticated, user, isLoading, logout } = useAuth0();
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/outline";
    const [farmRoleName, setFarmRoleName] = useLocalStorage('farmRoleName', null);
    const [defaultFarmName, setDefaultFarmName] = useLocalStorage('defaultFarmName', '');
    const [defaultFarmUniqueId, setDefaultFarmUniqueId] = useLocalStorage('defaultFarmUniqueId', null);
    const [itemDeletesaving, setItemDeleteSaving] = useState('');
    const [itemDeletePopup, setItemDeletePopup] = useState({ showItemDeletePopup: false, userId: '' });
    const handleItemDeletePopupClose = () => {
        setItemDeletePopup({ showItemDeletePopup: false });
        logout();
        return false;
    }
    useEffect(() => {
        if (isAuthenticated) {
            const auth0UserValidate = async () => {
                try {
                    const response = await axios.post(
                        '/api/auth/Auth0UserValidate/', JSON.stringify(
                            {
                                email : user.email
                            }), {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    });
                    if (response.data.isLoginSuccess) {

                        if (response.data.roleName != 'SWNZ Admin' && response.data.farmList.length == 0) {
                            alert("This user does not have any farms assigned. Please assign at least 1 farm.");
                            return false;
                        }

                        const token = response?.data?.accessToken;
                        const refreshToken = response?.data?.refreshToken;
                        const guid = response.data.guid;
                        const roles = response.data.roles;
                        const fullName = response.data.fullName;
                        const email = response.data.email;
                        const role = response.data.role;
                        const defaultFarmId = response.data.defaultFarmId == null ? 0 : response.data.defaultFarmId;
                        const farmList = response.data.farmList;
                        const loggedInUserId = response.data.id;
                        const defaultFarmName = response.data.defaultFarmName;
                        const defaultFarmUniqueId = response.data.defaultFarmUniqueId;
                        const profilePictureUrl = response.data.profilePictureUrl;
                        const roleName = response.data.roleName;
                        const farmRoleName = response.data.farmRoleName;
                        const isAddArchiveItem = response.data.isAddArchiveItem;
                        const isAddEditItem = response.data.isAddEditItem;
                        const isCreateNewAction = response.data.isCreateNewAction;
                        const isSubmitEvidenceCloseAction = response.data.isSubmitEvidenceCloseAction;
                        const isAddDeleteDocument = response.data.isAddDeleteDocument;
                        const saveRightsForNonItemFieldsAndTables = response.data.saveRightsForNonItemFieldsAndTables;
                        const tcAccepted = response.data.tcAccepted;
                        const isSuperAdmin = response.data.isSuperAdmin;
                        const user = {
                            email: email,
                            role: role,
                            username: email,
                            fullName: fullName,
                            roles: roles,
                            guid: guid,
                            token: token,
                            refreshToken: refreshToken,
                            defaultFarmId: defaultFarmId,
                            defaultFarmName: defaultFarmName,
                            defaultFarmUniqueId: defaultFarmUniqueId,
                            profilePictureUrl: profilePictureUrl,
                            farmList: farmList,
                            loggedInUserId: loggedInUserId,
                            roleName: roleName,
                            farmRoleName: farmRoleName,
                            isAddArchiveItem: isAddArchiveItem, isAddEditItem: isAddEditItem, isCreateNewAction: isCreateNewAction, isSubmitEvidenceCloseAction: isSubmitEvidenceCloseAction,
                            isAddDeleteDocument: isAddDeleteDocument, saveRightsForNonItemFieldsAndTables: saveRightsForNonItemFieldsAndTables
                        }
                        setAuth(user); // store all auth info in auth object (global context)

                        // save same details in localStorage. TODO: investigate how to save setAuth at once
                        localStorage.setItem("auth", JSON.stringify(user));
                        localStorage.setItem("defaultFarmId", JSON.stringify(defaultFarmId));
                        //localStorage.setItem("defaultFarmName", JSON.stringify(defaultFarmName));
                        setDefaultFarmName(defaultFarmName);
                        setDefaultFarmUniqueId(defaultFarmUniqueId);
                        //localStorage.setItem("defaultFarmUniqueId", JSON.stringify(defaultFarmUniqueId));
                        localStorage.setItem("loggedInUserId", loggedInUserId);
                        localStorage.setItem("roleName", roleName);
                        //localStorage.setItem("farmRoleName", farmRoleName);
                        setFarmRoleName(farmRoleName);
                        localStorage.setItem("isAddArchiveItem", isAddArchiveItem);
                        localStorage.setItem("isAddEditItem", isAddEditItem);
                        localStorage.setItem("isCreateNewAction", isCreateNewAction);
                        localStorage.setItem("isSubmitEvidenceCloseAction", isSubmitEvidenceCloseAction);
                        localStorage.setItem("isAddDeleteDocument", isAddDeleteDocument);
                        localStorage.setItem("saveRightsForNonItemFieldsAndTables", saveRightsForNonItemFieldsAndTables);
                        localStorage.setItem("accessToken", user.token);
                        localStorage.setItem("isSuperAdmin", isSuperAdmin);
                        if (!tcAccepted) {
                            window.open("/home", "_self");
                        }
                        else {
                            handleLandingPage(farmList, defaultFarmId, roleName);
                        }

                    }
                    else if (response.data.errorMessage == 'Other user sessions Exist') {
                        setItemDeletePopup({ showItemDeletePopup: true, userId: response.data.id });
                    }
                    else if (response.data.errorMessage == 'User not found') {
                        alert('User not found in fwfp application');
                        logout();
                        return false;
                    }
                } catch (error) {
                    console.error("Error fetching data:", error);
                }
            };
            auth0UserValidate();

        } else if (!isLoading) {
            navigate("/auth0login"); // Redirect if not authenticated
        }
    }, [isAuthenticated, isLoading, user, navigate]);

    const handleLandingPage = async (farmList, defaultFarmId, roleName) => {
        try {
            if (roleName == 'SWNZ Admin') {
                window.open("/myvineyardsummary", "_self");
            }
            else if (farmList.length == 1) {
                // go to outline page if user has one farm associated
                const response = await apiGet(
                    '/api/wizard/GetWizardDetails/', {
                    params: {
                        farmId: defaultFarmId
                    }
                }
                );
                if (response.data != null) {
                    if (response.data.isCompleted) {
                        window.open("/summary", "_self");
                    } else {
                        window.open(response.data.landingPage, "_self");
                    }
                }

            }
            else if (farmList.length > 1) {
                // go to farm selector page if user has more than one farm
                window.open("/myvineyardsummary", "_self");
            }
            else {
                // otherwise go to where it came from
                if (defaultFarmId == 0) {
                    window.open("/", "_self");
                } else {
                    navigate(from, { replace: true });
                }
            }


        } catch (error) {
            console.error('Error:', error);
        }

    }

    const continueLogin = async (event) => {
        setItemDeleteSaving(true);
        var userid = itemDeletePopup.userId;
        var form = {
            UserId: userid
        };
        try {
            const response = await axios.post(
                '/api/auth/ContinueLogin/', JSON.stringify(form), {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
            if (response.data.isLoginSuccess) {
                if (response.data.roleName != 'SWNZ Admin' && response.data.farmList.length == 0) {
                    alert("This user does not have any farms assigned. Please assign at least 1 farm.");
                    return false;
                }

                const token = response?.data?.accessToken;
                const refreshToken = response?.data?.refreshToken;
                const guid = response.data.guid;
                const roles = response.data.roles;
                const fullName = response.data.fullName;
                const email = response.data.email;
                const role = response.data.role;
                const defaultFarmId = response.data.defaultFarmId == null ? 0 : response.data.defaultFarmId;
                const farmList = response.data.farmList;
                const loggedInUserId = response.data.id;
                const defaultFarmName = response.data.defaultFarmName;
                const defaultFarmUniqueId = response.data.defaultFarmUniqueId;
                const profilePictureUrl = response.data.profilePictureUrl;
                const roleName = response.data.roleName;
                const farmRoleName = response.data.farmRoleName;
                const isAddArchiveItem = response.data.isAddArchiveItem;
                const isAddEditItem = response.data.isAddEditItem;
                const isCreateNewAction = response.data.isCreateNewAction;
                const isSubmitEvidenceCloseAction = response.data.isSubmitEvidenceCloseAction;
                const isAddDeleteDocument = response.data.isAddDeleteDocument;
                const saveRightsForNonItemFieldsAndTables = response.data.saveRightsForNonItemFieldsAndTables;
                const tcAccepted = response.data.tcAccepted;
                const isSuperAdmin = response.data.isSuperAdmin;
                const user = {
                    email: email,
                    role: role,
                    username: email,
                    fullName: fullName,
                    roles: roles,
                    guid: guid,
                    token: token,
                    refreshToken: refreshToken,
                    defaultFarmId: defaultFarmId,
                    defaultFarmName: defaultFarmName,
                    defaultFarmUniqueId: defaultFarmUniqueId,
                    profilePictureUrl: profilePictureUrl,
                    farmList: farmList,
                    loggedInUserId: loggedInUserId,
                    roleName: roleName,
                    farmRoleName: farmRoleName,
                    isAddArchiveItem: isAddArchiveItem, isAddEditItem: isAddEditItem, isCreateNewAction: isCreateNewAction, isSubmitEvidenceCloseAction: isSubmitEvidenceCloseAction,
                    isAddDeleteDocument: isAddDeleteDocument, saveRightsForNonItemFieldsAndTables: saveRightsForNonItemFieldsAndTables
                }

                setAuth(user); // store all auth info in auth object (global context)

                // save same details in localStorage. TODO: investigate how to save setAuth at once
                localStorage.setItem("auth", JSON.stringify(user));
                localStorage.setItem("defaultFarmId", JSON.stringify(defaultFarmId));
                setDefaultFarmName(defaultFarmName);
                setDefaultFarmUniqueId(defaultFarmUniqueId);
                localStorage.setItem("loggedInUserId", loggedInUserId);
                localStorage.setItem("roleName", roleName);
                setFarmRoleName(farmRoleName);
                localStorage.setItem("isAddArchiveItem", isAddArchiveItem);
                localStorage.setItem("isAddEditItem", isAddEditItem);
                localStorage.setItem("isCreateNewAction", isCreateNewAction);
                localStorage.setItem("isSubmitEvidenceCloseAction", isSubmitEvidenceCloseAction);
                localStorage.setItem("isAddDeleteDocument", isAddDeleteDocument);
                localStorage.setItem("saveRightsForNonItemFieldsAndTables", saveRightsForNonItemFieldsAndTables);
                localStorage.setItem("accessToken", user.token);
                localStorage.setItem("isSuperAdmin", isSuperAdmin);
                if (!tcAccepted) {
                    window.open("/home", "_self");
                }
                else {
                    handleLandingPage(farmList, defaultFarmId, roleName);
                }
            }
            setItemDeletePopup({ showItemDeletePopup: false });
        }
        catch (err) {
            if (!err?.response) {
                alert("No server response!")
                logout();
                return false;
            } else if (err.response?.status === 400) {
                alert("Login failed!")
                logout();
                return false;
            } else {
                alert("Login failed!")
                logout();
                return false;
            }
        }
    }

    if (isLoading) return <p>Loading...</p>;

    return (
        <div>
            {isAuthenticated ? (
                <>
                    {!itemDeletePopup.showItemDeletePopup && <div>Redirecting to home...</div>}
                </>
            ) : (
                <p>Redirecting to login...</p>
            )}
            <Modal isOpen={itemDeletePopup.showItemDeletePopup}>
                <ModalHeader toggle={handleItemDeletePopupClose} >User session exist</ModalHeader>
                <ModalBody>
                    This user is stil currently logged on to another device. If you continue the other session will be closed. Are you sure you wish to continue?
                </ModalBody>
                <ModalFooter>
                    {itemDeletesaving ?
                        <>
                            <Button onClick={continueLogin} color="primary" disabled>
                                <Row>
                                    <Col sm="6">
                                        <span>
                                            {' '}Processing
                                        </span>
                                    </Col>
                                    <Col sm="6">
                                        <Spinner size="sm">
                                            Processing...
                                        </Spinner>
                                    </Col>
                                </Row></Button>{' '}
                        </>
                        :
                        <>
                            <Button onClick={continueLogin} color="primary">
                                Yes
                            </Button>{' '}
                        </>
                    }
                    <Button color="danger" onClick={handleItemDeletePopupClose}>No</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default Auth0Success;